import { render, staticRenderFns } from "./ScheduleMailer.vue?vue&type=template&id=48e0947a&"
import script from "./ScheduleMailer.vue?vue&type=script&lang=js&"
export * from "./ScheduleMailer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports